<template>
    <div class="row margin-bottom-30" v-if="widgetReady">
        <div class="col-md-3">
            <div class="form-group">
                <input v-model="vm.name" id="discName" class="form-control"/>
            </div>
        </div>
        <div class="col-md-6 slider-widget">
            <span id="slider-left" class="hidden">low value</span>
            <span id="slider-right" class="hidden">high value</span>
            <b><i class="fa fa-user"></i> 1 </b>
            <input type="text" ref="slider"/>
            <b><i class="fa fa-users"></i> 15 </b>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <input type="text" class="form-control" id="IndividualPercentage"
                        v-model="vm.discountBundleDetails.individualDiscount">
            </div>
        </div>
    </div>
</template>

<script>

    import {api} from "../../../../global/framework/api.js";
    import {mapGetters} from 'vuex';
	import _ from 'lodash';
	import Slider from 'bootstrap-slider';
    require('bootstrap-slider/dist/css/bootstrap-slider.min.css');

    export default {
        name: "AddDiscountForm",
        props: {
            value: {type: Object, required: true},
        },
        data() {
            return {
                widgetReady: false,
				slider: null,
                vm: {
                    ...(this.clone(this.value)),
                    editMode: false,
                },
            }
        },
        computed: {
            isRowBeingEdited() {
                if (this.discounts.some(d => d.editMode == true)) {
                    return true;
                }
                return false;
            },
        },
        methods: {
            async getDiscount() {
                //add validation here
                //let result = await api.post('Discount', 'ValidateDiscount', this.vm, true);
                return this.vm;
                return false;
            },
            async initOrReload() {
                let min = this.vm.discountBundleDetails.minRange == 0 ? 1 : this.vm.discountBundleDetails.minRange;
                let max = this.vm.discountBundleDetails.maxRange == 0 ? 15 : this.vm.discountBundleDetails.maxRange;

                this.setEditMode(min, max);
                this.widgetReady = true;
            },
            async setEditMode(min, max) {
				this.createSliderOrReload(min, max);
			},
			async createSliderOrReload(min, max) {
				if (this.slider == null) {
					await this.$nextTick();
					this.slider = $(this.$refs.slider).slider({
						min: 1,
						max: 15,
						tooltip: 'always',
						value: [min, max],
						labelledby: ['slider-left', 'slider-right']
					}).data('slider');
					let self = this;
					this.slider.on('change', function (event) {
						self.vm.discountBundleDetails.minRange = event.newValue[0];
						self.vm.discountBundleDetails.maxRange = event.newValue[1];
					})
				}
				this.vm.discountBundleDetails.minRange = min;
				this.vm.discountBundleDetails.maxRange = max;
				this.slider.setValue([min, max]);
			}
        },
        async mounted() {
            await this.initOrReload();
            this.widgetReady = true;
        },
    }
</script>

<style scoped>
    .slider-widget /deep/ .slider-selection {
		background: green;
	}
    .slider-widget {
        margin-top: 10px;
    }
    .slider-widget /deep/ .slider-horizontal {
        margin-left: 8px;
        margin-right: 8px;
    }
    .margin-bottom-30 {
        margin-bottom: 30px;
    }
</style>